import { IArticle } from "@/Models/ArticleModels/article";
import { SyndicationArticleClient, ArticleType, ArticleModel, ISyndicationArticleClient, ContentSearchHit } from "@/Generated/ParticaAPI";
import { ArticleUtils } from "./articleutils";

export interface IArticleService {
	getArticle(hit: ContentSearchHit): Promise<IArticle>;
}

export class ArticleService implements IArticleService {
	private svc: ISyndicationArticleClient = new SyndicationArticleClient();
	private utils: ArticleUtils = new ArticleUtils();

	public async getArticle(hit: ContentSearchHit): Promise<IArticle> {
		let result: IArticle | undefined;
		const model: ArticleModel = await this.svc.getArticle(hit.issueId as number, hit.articleId as string);
		result = this.utils.convertarticle(model);
		return result as IArticle;
	}
}
